// src/services/categoryService.js
import api from "../api";

/**
 * Публічне дерево категорій (БЕЗ прихованих)
 */
export async function getCategories() {
  const { data } = await api.get("/categories");
  return data;
}

/**
 * Адмінське дерево категорій (З прихованими)
 */
export async function getCategoriesAdmin() {
  const { data } = await api.get("/categories", { params: { includeHidden: 1 } });
  return data;
}

/**
 * Створення категорії (multipart/form-data)
 */
export async function createCategory(formData) {
  const { data } = await api.post("/categories", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/**
 * Оновлення категорії (multipart/form-data)
 */
export async function updateCategory(id, formData) {
  const { data } = await api.put(`/categories/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/**
 * Видалення категорії
 */
export async function deleteCategory(id) {
  const { data } = await api.delete(`/categories/${id}`);
  return data;
}

/**
 * Перестановка порядку братів
 */
export async function reorderCategories(parentId, orderedIds) {
  const { data } = await api.patch("/categories/reorder", { parentId, orderedIds });
  return data;
}

/**
 * ✅ Приховати/показати категорію
 * PATCH /api/categories/:id/visibility
 * body: { isHidden: true/false }
 */
export async function setCategoryVisibility(id, isHidden) {
  const { data } = await api.patch(`/categories/${id}/visibility`, { isHidden });
  return data;
}


// import api from "../api";

// export async function getCategories() {
//   const { data } = await api.get("/categories");
//   return data;
// }

// export async function createCategory(formData) {
//   const { data } = await api.post("/categories", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return data;
// }

// export async function updateCategory(id, formData) {
//   const { data } = await api.put(`/categories/${id}`, formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return data;
// }

// export async function deleteCategory(id) {
//   const { data } = await api.delete(`/categories/${id}`);
//   return data;
// }

// export async function reorderCategories(parentId, orderedIds) {
//   const { data } = await api.patch("/categories/reorder", { parentId, orderedIds });
//   return data;
// }



